import "@/main.ts";
import * as ActiveStorage from "@rails/activestorage";
import ahoy from "ahoy.js";

ActiveStorage.start();

ahoy.configure({
  cookies: false,
});

// Custom click tracking handler - supports both old and new attribute patterns
// Old: data-click-tracking="true" (backward compatible)
// New: data-track="semantic_name" for additional semantic identification
document.addEventListener(
  "click",
  (event) => {
    const target = (event.target as HTMLElement).closest(
      "[data-track], [data-click-tracking=true]"
    ) as HTMLElement | null;
    if (!target) return;

    const sectionEl = target.closest("[data-section]");

    ahoy.track("$click", {
      // Standard ahoy properties (backward compatible)
      tag: target.tagName.toLowerCase(),
      id: target.id ?? undefined,
      class: target.className ?? undefined,
      page: window.location.pathname,
      section: sectionEl?.getAttribute("data-section") ?? undefined,
      text:
        target.tagName === "INPUT"
          ? (target as HTMLInputElement).value
          : target.textContent?.trim().substring(0, 100),
      href: target.getAttribute("href") ?? undefined,
      // Semantic identifier (new) - use alongside id for flexibility
      name: target.getAttribute("data-track") ?? undefined,
    });
  },
  true
);
